<template>
  <vue-gantt :tasks="tasks"
             :config="config"
             :sortColumn="sortColumn"
             :isAscending="isAscending"
             :taskColors="taskColors"
             :taskInfo="taskInfo"
             :dataFormat="dataFormat"
             @onTaskClick="onTaskClick"></vue-gantt>

</template>
<script>
  // import VueGantt from "./vue-gantt.vue"

  export default {
    name: "vue-gantt-lazy",
    /* components:{
       VueGantt
     },*/
    data() {
      return {
        clicked: {},
        tasks: {data: [], links: []}
      }
    },
    props: {
      lazyLoad:{
        type: Boolean,
        default:true
      },
      url: {
        type: String,
        default: "/api/gantt"
      },
      taskInfo: {
        type: Object,
        default: null
      },
      itemExtendParam: {
        type: String,
        default: "task_id"
      },
      config: {
        type: Object,
        default: () => ({})
      },
      sortColumn: {
        type: String,
      },
      isAscending: {
        type: Boolean,
        default: true
      },
      taskColors: {
        type: Object,
        default: () => ({})
      },
      dataFormat: {
        type: String,
        default: "DD-MM-YYYY HH:mm:ss"
      }
    },
    mounted() {
      this.$axios.get(this.url).then(r => r.data).then(data => {
        this.tasks = data;
      });
    },
    methods: {
      onTaskClick(task) {
        if(!this.lazyLoad) return;
        if (this.clicked[task.id]) return;
        this.$set(this.clicked, task.id, true);
        this.clicked[task.id] = true;
        this.$axios.get(this.url, {params: {[this.itemExtendParam]: task.id}})
          .then(r => {
            let data = r.data;
            this.tasks.data.push(...data.data.filter(i => !this.dataLoaded[i.id]));
            this.tasks.links.push(...data.links.filter(i => !this.linksLoaded[i.id]));
            gantt.open(task.id);
          });
      }
    },

    computed: {
      dataLoaded() {
        return this.tasks.data.reduce((a, b) => {
          a[b.id] = true;
          return a;
        }, {});
      },
      linksLoaded() {
        return this.tasks.links.reduce((a, b) => {
          a[b.id] = true;
          return a;
        }, {});
      }
    }
  }
</script>
